import styled, { css } from 'styled-components';

export const CounterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  color: ${({ theme }) => theme.black};
`;

export const CounterLabel = styled.p`
  margin: 0;
  padding: 0;

  font-size: 16px;
  line-height: 1;
`;

export const CounterContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CounterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin: 0;
  padding: 0;

  background-color: #f3f6f8;
  border: none;
  border-radius: 50%;
  outline: none;

  cursor: pointer;

  svg {
    fill: ${({ dis, theme }) => dis ?  "#696969" : theme.blue};
  }
`;

export const Counter = styled.span`
  margin: 0 15px;

  font-weight: 700;
  font-size: 16px;

  ${({ hiddenCounter }) => hiddenCounter && css`
    margin: 0 3px;

    font-size: 0;
  `}
`;
